import React, { FC } from 'react'
import {
  Avatar,
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { SPACING } from '@/shared/styles/spacing'
import ReactMarkdown from 'react-markdown'

/**
 * マイク権限に関するヘルプページ
 */
export const MicPermissionHelpPage: FC = () => {
  const tableData = [
    {
      os: 'Windows',
      version: '10, 11',
      browser: 'Chrome',
      versionBrowser: '133',
    },
    {
      os: 'Windows',
      version: '10, 11',
      browser: 'Edge',
      versionBrowser: '132',
    },
    { os: 'macOS', version: '15', browser: 'Safari', versionBrowser: '18' },
    { os: 'macOS', version: '15', browser: 'Chrome', versionBrowser: '133' },
    { os: 'iOS', version: '17, 18', browser: 'Safari', versionBrowser: '18' },
    { os: 'iOS', version: '17, 18', browser: 'Chrome', versionBrowser: '133' },
  ]

  const OsBrowserTable = (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>OS</TableCell>
            <TableCell>バージョン</TableCell>
            <TableCell>ブラウザ</TableCell>
            <TableCell>バージョン</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.os}</TableCell>
              <TableCell>{row.version}</TableCell>
              <TableCell>{row.browser}</TableCell>
              <TableCell>{row.versionBrowser}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )

  const markdownText1 = `
ここではマイク接続ができない場合の対処法をまとめています。
以下の1.ブラウザ及びOSと2,マイクの権限設定を確認してください。

## 1.ブラウザ及びOS
お使いのブラウザおよびOSがサポート対象外の可能性がございます。
現在以下のOSおよびブラウザでの動作を確認していますので下記の組み合わせへの移行、アップデートをお願いいたします。`

  const markdownText2 = `
## 2.マイクの権限設定
マイクの権限が「拒否」になっている場合、録音ができません。
以下の手順で権限を「許可」に変更してください。

1. "PC本体の設定"からマイク出力設定を対象の使用しているマイクに変更
2. "ブラウザ側のマイク設定"からマイク権限を許可に変更
---

ブラウザ側のマイク設定は、一度「拒否」してしまった場合、ブラウザの設定から手動で再度「許可」に変更する必要があります。
`

  return (
    <Stack
      sx={{ width: '100%', p: SPACING.mainContent }}
      direction="column"
      spacing={3}
      alignItems="center"
      justifyContent="center"
    >
      {/* タイトル部分 */}
      <Stack direction="column" alignItems="center" spacing={1}>
        <Avatar />
        <Typography component="h1" variant="h5" textAlign={'center'}>
          マイク接続ができない場合
        </Typography>
      </Stack>

      {/* コンテンツ部分 */}
      <Box width="80%">
        <Stack direction="column" spacing={3}>
          <ReactMarkdown>{markdownText1}</ReactMarkdown>
          {OsBrowserTable}
          <ReactMarkdown>{markdownText2}</ReactMarkdown>
        </Stack>
      </Box>
    </Stack>
  )
}
